<!-- Loading state - DISABLED -->
<!-- <div *ngIf="!isDataLoaded" class="loading-container">
    <div class="loading-spinner hidden">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
        <p class="loading-text">Loading report data...</p>
    </div>
</div> -->

<!-- Main content - only show when data is loaded -->
<div class="repDTable">
<div *ngIf="isDataLoaded" class="container-fluid pl-4 pr-4">
    <div class="biActPanel">
        <div class="biRepDLeft">
            <div class="expNavIcon"><a (click)="showCompanyReportsSubMenu()"><img src="assets/images/expBtn-icon.svg"
                        alt="" /></a>
            </div>
            <div>
                <div class="backLink"><a href="#"><i class="pi pi-arrow-left"></i> {{reportConfig.reportName}}</a></div>
                <div class="biRepT-2">
                    <!-- {{(loadedSavedReportData) ? (savedReportData.savedReports[0].reportName) :
                    reportConfig.reportName}}  -->

                    <span [pTooltip]="((loadedSavedReportData && savedReportData.savedReports && savedReportData.savedReports[0]) ? (savedReportData.savedReports[0].reportName) :
                    reportConfig.reportName)" tooltipPosition="top" style="cursor: pointer;">
                        {{ ((loadedSavedReportData && savedReportData.savedReports && savedReportData.savedReports[0]) ?
                        (savedReportData.savedReports[0].reportName) :
                        reportConfig.reportName) | slice:0:25 }}{{ ((loadedSavedReportData &&
                        savedReportData.savedReports && savedReportData.savedReports[0]) ?
                        (savedReportData.savedReports[0].reportName) : reportConfig.reportName) &&
                        ((loadedSavedReportData && savedReportData.savedReports && savedReportData.savedReports[0]) ?
                        (savedReportData.savedReports[0].reportName) :
                        reportConfig.reportName).length > 25 ? '...' : '' }}
                    </span>
                    <div class="biRIconList ml-1" *ngIf="(reportId != 0)">
                        <a he class="ml-0" href="javascript:void(0)" tooltipStyleClass="midTT"
                            pTooltip="{{(loadedSavedReportData && savedReportData.savedReports && savedReportData.savedReports[0]) ? (savedReportData.savedReports[0].reportDesc) : reportConfig.reportDescription}}"
                            tooltipPosition="bottom"><img src="assets/images/info-icon.svg" alt="" /></a>
                        <!-- isReportLevelSecurity -->
                        <a href="javascript:void(0)" *ngIf ="savedReportData.savedReports && savedReportData.savedReports[0] && savedReportData.savedReports[0].privileges != 1" (click)="visible2 = true"><img 
                                src="assets/images/report-security.svg"
                                (click)="showReportSecurity(savedReportData.savedReports && savedReportData.savedReports[0] ? savedReportData.savedReports[0] : null)"
                                alt="" pTooltip="Report Security" tooltipPosition="top" 
                                [class]="(loadedSavedReportData && savedReportData.savedReports && savedReportData.savedReports[0] && savedReportData.savedReports[0].isReportLevelSecurity == 1) ? 'activeIcon' : ''" /></a>
                        <img src="assets/images/tag-icon-light.svg" *ngIf="savedReportData.savedReports && savedReportData.savedReports[0] && savedReportData.savedReports[0].isAdminReport == 1"
                            [class]="(loadedSavedReportData && savedReportData.savedReports && savedReportData.savedReports[0] && savedReportData.savedReports[0].isTaggedReport == 1) ? 'activeIcon' : ''"
                            alt=""
                            (click)="tagAndUntagReport(savedReportData.savedReports && savedReportData.savedReports[0] ? savedReportData.savedReports[0] : null)"
                            [pTooltip]="getTaggedReportTooltip()" tooltipPosition="top" />
                        <img (click)="showScheduleReport(savedReportData.savedReports && savedReportData.savedReports[0] ? savedReportData.savedReports[0] : null)"
                            src="assets/images/scheduleReport-icon.svg"
                            [class]="(savedReportData.savedReports && savedReportData.savedReports[0] &&savedReportData.savedReports[0].isScheduledReport) ? 'activeIcon' : ''"
                            alt=""  [pTooltip]="getScheduleReportTooltip()" tooltipPosition="top" />
                    </div>
                </div>
            </div>
        </div>
        <div class="biRepDRight">
            <!-- Days filter start -->
            <div class="biRAct-b1">
                <a class="cursor-pointer" *ngFor="let dateRange of filteredDateRanges"
                    [class.active]="dateRange.code == reportFormData.periodValue"
                    (click)="selectDateRange(dateRange)"
                    [pTooltip]="getDateRangeTooltip(dateRange)"
                    pTooltipPosition="bottom"
                    tooltipPosition="bottom">{{dateRange.name}}</a>
            </div>
            <!-- Days filter end -->
            <div class="biRepDateP" *ngIf="reportFormData.periodValue != 18">
                <p-datepicker appendTo="body" #multiDatePicker [dateFormat]="defaultDateFormat" showIcon icon="custom-calendar-icon"
                    selectionMode="range" inputId="multiDatePicker" [numberOfMonths]="1" [(ngModel)]="dateRange"
                    [hideOnDateTimeSelect]="false" [keepInvalid]="true" [readonlyInput]="true">
                    <ng-template #date let-date>
                        {{ date.day }}
                    </ng-template>
                    <ng-template #footer>
                        <div class="flex justify-content-end pop-footer">
                            <p-button class="pop-save" label="Generate" (click)="dateRangeChanged()"
                                (click)="closeDatePicker()" [disabled]="!isDateRangeValid()" />
                            <p-button class="pop-cancel" [outlined]="true" severity="secondary" label="Cancel"
                                (click)="closeDatePicker()" />
                        </div>
                    </ng-template>
                </p-datepicker>
            </div>
            <div class="biRSwTab"
                *ngIf="reportFormData.reportType == ReportType.SUMMARY_REPORT || reportFormData.reportType == ReportType.GRAPH_REPORT || reportFormData.reportId == 109 || reportFormData.reportId == 9">
                <a class="biRListBtn" [ngClass]="{'active':!isGraphReport}"
                    (click)="toggleGraphAndTable(1)"><span></span></a>
                <a class="biRGraphBtn" [ngClass]="{'active':isGraphReport}"
                    (click)="toggleGraphAndTable(2)"><span></span></a>
            </div>
            <!-- Hierarchy Toggle Button -->
            <div class="biRSwTab hidden" *ngIf="hasHierarchyData()">
                <a class="biRHierarchyBtn" [ngClass]="{'active':showHierarchyReport}"
                    (click)="toggleHierarchyView()" pTooltip="Toggle Hierarchy View" tooltipPosition="top">
                    <i class="pi pi-sitemap"></i>
                </a>
            </div>
            <div class="biRSwTab menuMd">
                <div class="exportList">
                    <div *ngIf="actionType == 1 && checkExportPermission()">
                        <p-menu [model]="tableExportItems" [popup]="true" #menu>
                            <ng-template let-item pTemplate="item">
                                <a href="#" (click)="exportReport(item.type, actionType)"
                                    *ngIf="((item.type != 'schedule') || (item.type == 'schedule' && savedReportData.savedReports && savedReportData.savedReports[0])) && (item.type != 'mobile') && (item.type != 'custom_api')">
                                    <img [src]="'assets/images/'+item.image" />
                                    {{ item.label }}
                                </a>
                            </ng-template>
                        </p-menu>
                        <p-button (click)="menu.toggle($event)"><img src="assets/images/share-icon.svg"
                                alt="" /></p-button>
                    </div>
                    <div *ngIf="actionType == 2" class="expIcons">
                        <p-menu [model]="graphExportItems" [popup]="true" #menu>
                            <ng-template let-item pTemplate="item">
                                <a href="#" (click)="exportReport(item.type, actionType)" [class]="item.class">
                                    <img [src]="'assets/images/'+item.image" />
                                    {{ item.label }}
                                </a>
                            </ng-template>
                        </p-menu>
                        <p-button (click)="menu.toggle($event)"><img src="assets/images/share-icon.svg"
                                alt="" /></p-button>
                    </div>
                </div>

                <div class="repMenuBtn"
                    *ngIf="(reportFormData.reportType !== ReportType.DETAILED_REPORT && reportFormData.reportType !== ReportType.DIMENSION_REPORT) || actionType == 2">
                    <!-- Graph menu list -->
                    <p-menu [model]="graphItems" [popup]="true" #reportmenu>
                        <ng-template #submenuheader let-item>
                            <span class="font-bold">{{ item.label }}</span>
                        </ng-template>
                        <ng-template let-item pTemplate="item">
                            <!-- Graph Items -->
                            <a *ngIf="item.type == 0" href="#" class="{{item.class}}" (click)="activateGraph(item)">
                                <img [src]="item.image" />
                                <div>{{ item.label }}</div>
                            </a>
                            <a *ngIf="item.type == 1" class="flex" (click)="onShowMoreClick($event,1)">
                                {{ item.label }}<i class="pi pi-angle-down"></i>
                            </a>
                            <!-- Show More Items -->
                            <a *ngIf="item.type == 2" class="flex" (click)="onShowMoreClick($event,2)">
                                {{ item.label }}<i class="pi pi-angle-up"></i>
                            </a>
                        </ng-template>

                    </p-menu>
                    <!-- Graph menu list End -->
                    <!-- Graph menu click -->
                    <ng-container *ngIf="actionType == 2">
                        <p-button (click)="onReportMenuClick($event)"><img src="assets/images/report-icon.svg"
                                alt="" /></p-button>
                    </ng-container>
                    <!-- Graph menu click End -->
                </div>
                <div class="biRSettings" *ngIf="savedReportData.savedReports && savedReportData.savedReports[0]">
                    <p-menu [model]="itemsSetting" [popup]="true" #listSetting>
                        <ng-template let-item pTemplate="item">
                            <a href="#" (click)="showMobileReport()" *ngIf="item.type == 'mobile'"> <img [src]="'assets/images/'+item.image" /> {{ item.label }}
                            </a>
                            <a href="#" (click)="showCustomReportApi($event)" *ngIf="item.type == 'custom_api' && checkCustomReportApiPermission()"><img [src]="'assets/images/'+item.image" /> {{ item.label }}
                            </a>

                        </ng-template>
                    </p-menu>

                    <p-button (click)="listSetting.toggle($event)"><img src="assets/images/setting-icon.svg"
                            alt="" /></p-button>
                </div>
            </div>
            <div class="biRSwTab">
                <a (click)="showFiltersBlock()"><img src="assets/images/filter-icon.svg" pTooltip="Edit Filters" tooltipPosition="top" alt="" /></a>
                <a (click)="showColumnsBlock()"><img src="assets/images/coulmn.svg" pTooltip="Edit Columns" tooltipPosition="top" alt="" /></a>
            </div>
            <div class="saveReport">
                <p-button (click)="showGenerateReportForm()" label="Save Report" />
            </div>
        </div>
    </div>
    <!-- Hierarchy Report View -->
    <div class="card biRepTable" *ngIf="showHierarchyReport && hasHierarchyData()">
        <bi-hierarchy-report 
            [hierarchyData]="hierarchyData"
            [columns]="hierarchyColumns"
            [showSums]="true"
            [expandAll]="false" (getDrilldownReportInfo)="getDrilldownReportInfo($event)">
        </bi-hierarchy-report>
    </div>

    <div class="fltChips flex align-items-center flex-wrap gap-2 mt-3" *ngIf="hasActiveFilters()">
        <p-chip 
            *ngFor="let filter of getVisibleActiveColumnFilters()" 
            [label]="filter.columnName + ': ' + getActiveFilterDisplayValue(filter)" 
            [removable]="true" 
            removeIcon="pi pi-times"
            (onRemove)="removeFilterChip(filter)"
            tooltipPosition="top" />
        <button
            *ngIf="shouldShowMoreFilterChipsButton()"
            type="button"
            class="chip-toggle-btn"
            (click)="moreFiltersPopover.toggle($event)">
            {{ 'More (' + getRemainingFilterChipCount() + ')' }}
        </button>
        <button
            type="button"
            class="chip-clear-btn"
            (click)="clearAllFilterChips()">
            Clear
        </button>
    </div>
    <p-popover
        #moreFiltersPopover
        [dismissable]="true"
        appendTo="body"
        styleClass="more-filters-popover">
        <div class="more-filters-list" *ngIf="getRemainingActiveColumnFilters().length > 0">
            <div class="more-filter-item" *ngFor="let filter of getRemainingActiveColumnFilters()">
                <div class="more-filter-content">
                    <div class="more-filter-label">{{ filter.columnName }}</div>
                    <div class="more-filter-value">{{ getActiveFilterDisplayValue(filter) }}</div>
                </div>
                <button
                    type="button"
                    class="more-filter-remove"
                    (click)="removeFilterChip(filter)">
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </div>
    </p-popover>

    <!-- Regular Table View -->
    <div class="card biRepTable" *ngIf="!isGraphReport && !showHierarchyReport">
        <!-- Unified table for both grouped and ungrouped data -->
        <p-table [value]="getTableData()" [scrollable]="true" [scrollHeight]="getTableScrollHeight()" [paginator]="!shouldDisablePagination()" [rows]="rows"
            [first]="first" [totalRecords]="getTotalRecords()" [lazy]="true" [loading]="false" (onLazyLoad)="onLazyLoad($event)"
            [showCurrentPageReport]="!shouldDisablePagination()" [currentPageReportTemplate]="getCurrentPageReportTemplate()"
            [rowsPerPageOptions]="shouldDisablePagination() ? [] : rowsPerPageOptions" [showPageLinks]="!shouldDisablePagination()" [showFirstLastIcon]="!shouldDisablePagination()"
            styleClass="auto-width-table" [tableStyle]="{ width: 'auto' }">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let column of getUnifiedTableColumns()" class="auto-width-header"
                        [attr.data-column-id]="column"
                        [pTooltip]="getColumnDescription(column)"
                        [tooltipDisabled]="!getColumnDescription(column)"
                        tooltipPosition="top"
                        tooltipStyleClass="midTT">
                        <div class="flex align-items-center">
                            {{ getColumnInfo(column)?.columnName || column }}
                            <p-columnFilter #columnFilter (onShow)="getColumnFilterValue(column)"
                                *ngIf="getColumnInfo(column)?.searchType" class="thFltr" field="representative"
                                matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                [showAddButton]="false"
                                [ngClass]="{'column-filter-applied':  checkColumnFilterApplied(column)}">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <div class="filterHead">
                                        <div class="sort-filter-asc">
                                            <p-checkbox class="inline-flex"
                                                [(ngModel)]="columnSortStates[column + '_asc']" [binary]="true"
                                                [disabled]="isSortNullFilterDisabled(column)"
                                                (onChange)="handleSortSelection(column, 'asc')" size="large" />
                                            <label class="ml-2 mr-2">Sort</label>
                                            <a href="javascript:void(0)"><i class="pi pi-sort-alpha-down"></i></a>
                                        </div>
                                        <div class="sort-filter-asc m-0">
                                            <p-checkbox class="inline-flex"
                                                [(ngModel)]="columnSortStates[column + '_desc']" [binary]="true"
                                                [disabled]="isSortNullFilterDisabled(column)"
                                                (onChange)="handleSortSelection(column, 'desc')" size="large" />
                                            <label class="ml-2 mr-2">Sort</label>
                                            <a href="javascript:void(0)"><i class="pi pi-sort-alpha-down-alt"></i></a>
                                        </div>
                                        <div class="space-filter">&nbsp;</div>
                                        <div class="sort-filter-asc">
                                            <p-checkbox class="inline-flex"
                                                [(ngModel)]="columnNullStates[column + '_not_null']" [binary]="true"
                                                [disabled]="isSortNullFilterDisabled(column)"
                                                (onChange)="handleNullSelection(column, 'not_null')" size="large" />
                                            <label class="ml-2 mr-2">Is Not Null</label>
                                        </div>
                                        <div class="sort-filter-asc m-0">
                                            <p-checkbox class="inline-flex"
                                                [(ngModel)]="columnNullStates[column + '_null']" [binary]="true"
                                                [disabled]="isSortNullFilterDisabled(column)"
                                                (onChange)="handleNullSelection(column, 'null')" size="large" />
                                            <label class="ml-2 mr-2">Is Null</label>
                                        </div>
                                    </div>
                                    <div class="filterBody">
                                        <div class="field" *ngIf="getColumnInfo(column)?.searchType == 4">
                                            <p-multiselect optionLabel="name" optionValue="code"
                                                placeholder="Select {{getColumnInfo(column)?.columnName}}"
                                                [maxSelectedLabels]="3" [showToggleAll]="false"
                                                class="w-full md:w-80" [options]="columnLevelOptions[column]"
                                                [ngModel]="getSearchColumnValue(column)"
                                                (onChange)="updateSearchValue(column, $event.value)" />
                                        </div>
                                        <div class="field" *ngIf="getColumnInfo(column)?.searchType == 1">
                                            <input pInputText type="text"
                                                placeholder="Search {{getColumnInfo(column)?.columnName}}"
                                                class="w-full" [ngModel]="getSearchColumnValue(column)"
                                                (input)="updateSearchTextValue(column, $event)" />
                                        </div>
                                        <div class="field"  *ngIf="getColumnInfo(column)?.searchType == 2">
                                            <p-datePicker appendTo="body" [dateFormat]="defaultDateFormat" [showIcon]="true"
                                                placeholder="Select {{getColumnInfo(column)?.columnName}}"
                                                [showButtonBar]="true" class="w-full"
                                                [ngModel]="getSearchColumnValue(column)"
                                                (onSelect)="updateSearchValue(column, $event)" />
                                        </div>
                                    </div>
                                    <div class="filterFooter">
                                        <p-button class="mr-2" label="Search" severity="primary"
                                            (onClick)="submitSearch()" (click)="closeColumnFilter(columnFilter)" />
                                        <p-button class="mr-2" label="Reset" variant="outlined" severity="secondary"
                                            (onClick)="resetSearch(column)" (click)="closeColumnFilter(columnFilter)" />
                                        <p-button class="mr-2" label="Close" variant="outlined" severity="secondary"
                                            (click)="closeColumnFilter(columnFilter)" />
                                    </div>
                                </ng-template>
                            </p-columnFilter>

                        </div>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">


                <!-- Grouped Data Display -->
                <ng-container *ngIf="isGroupedData()">
                    <!-- Single Level Grouping -->
                    <ng-container *ngIf="shouldDisplaySingleLevelGrouping()">
                        <!-- Group Header Row -->
                        <tr
                            [class]="reportFormData.reportType != ReportType.DETAILED_REPORT ? 'group-header-row-level1' : 'group-header-row'"
                            [style.background-color]="getGroupRowBackground(rowData)">
                            <td *ngFor="let column of getUnifiedTableColumns(); let i = index"
                                [ngClass]="{'text-right': getColumnInfo(column)?.colDataType == '1'}"
                                [style.background-color]="getGroupRowBackground(rowData)">
                                <span *ngIf="i==0"
                                    [innerHTML]="getSafeHtml(formatValue(rowData.groupValue, column))"></span>
                                <span *ngIf="i>0">
                                    <span *ngIf="!isNumericColumn(getColumnInfo(column)) && getColumnInfo(column)?.colDataType != 3"
                                        [innerHTML]="getSafeHtml(formatGroupSum(rowData.groupSums, i, column))"></span>
                                    <span *ngIf="isNumericColumn(getColumnInfo(column))">
                                        <a class="cursor-pointer"
                                            *ngIf="shouldShowDrilldownLink(rowData.groupSums, i, column)"
                                            (click)="getDrilldownReport(rowData, column, 1)">
                                            {{formatGroupSum(rowData.groupSums, i, column)}}
                                        </a>
                                        <span *ngIf="shouldShowGroupSum(rowData.groupSums, i, column)">
                                            {{formatGroupSum(rowData.groupSums, i, column)}}
                                        </span>
                                    </span>
                                </span>
                            </td>
                        </tr>

                        <!-- Group Data Rows -->
                        <ng-container *ngIf="shouldShowGroupDetailRows()">
                            <tr *ngFor="let row of rowData.rows; let rowIndex = index" class="group-data-row">
                                <td *ngFor="let column of getUnifiedTableColumns(); let i = index"
                                    [ngClass]="{'text-right': getColumnInfo(column)?.colDataType == '1'}">
                                    <ng-container *ngIf="i === 0">
                                        <!-- Empty cell for first column -->
                                    </ng-container>
                                    <ng-container *ngIf="i > 0">
                                        <span *ngIf="!isNumericColumn(getColumnInfo(column))"
                                    [innerHTML]="getSafeHtml(formatValue(row[i], column))"></span>
                                        <span *ngIf="isNumericColumn(getColumnInfo(column))">
                                            <a ngClass="cursor-pointer"
                                                *ngIf="shouldShowRowDrilldownLink(row, i, column)"
                                                (click)="getDrilldownReport(row, column, 0)">
                                                {{ getRowDisplayValue(row, i, column) }}
                                            </a>
                                            <span *ngIf="!shouldShowRowDrilldownLink(row, i, column)">
                                                {{ getRowDisplayValue(row, i, column) }}
                                            </span>
                                        </span>
                                    </ng-container>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>

                    <!-- Two Level Grouping -->
                    <ng-container *ngIf="shouldDisplayTwoLevelGrouping()">
                        <!-- Level 1 Group Header Row -->
                        <tr class="group-header-row" [style.background-color]="getGroupRowBackground(rowData)">
                            <td *ngFor="let column of getUnifiedTableColumns(); let i = index"
                                [ngClass]="{'text-right': getColumnInfo(column)?.colDataType == '1'}"
                                [style.background-color]="getGroupRowBackground(rowData)">
                                <b>
                                    <span *ngIf="i==0"
                                    [innerHTML]="getSafeHtml(formatValue(rowData.groupValue, column))"></span>
                                    <span *ngIf="i>0">
                                        <span *ngIf="getColumnInfo(column)?.colDataType != '1' && getColumnInfo(column)?.colDataType != 3"
                                        [innerHTML]="getSafeHtml(formatGroupSum(rowData.groupSums, i, column))"></span>
                                        <span *ngIf="getColumnInfo(column)?.colDataType == '1'">
                                            <a ngClass="cursor-pointer"
                                                *ngIf="shouldShowDrilldownLink(rowData.groupSums, i, column)"
                                                (click)="getDrilldownReport(rowData, column, 1)">
                                                {{formatGroupSum(rowData.groupSums, i, column)}}</a>
                                            <span
                                                *ngIf="shouldShowGroupSum(rowData.groupSums, i, column)">{{formatGroupSum(rowData.groupSums,
                                                i, column)}}</span>
                                        </span>
                                    </span>
                                </b>
                            </td>
                        </tr>

                        <!-- Level 2 Subgroups -->
                        <ng-container *ngFor="let subgroup of rowData.subgroups">
                            <!-- Level 2 Group Header Row -->
                            <tr
                                [class]="!isSummaryOrDimensionReport() ? 'group-header-row-level2' : 'group-data-row'"
                                [style.background-color]="getGroupRowBackground(subgroup, !isSummaryOrDimensionReport())">
                                <td
                                    [class]="!isSummaryOrDimensionReport() ? 'group-name-cell-level2' : 'group-data-row'"
                                    [style.background-color]="getGroupRowBackground(subgroup, !isSummaryOrDimensionReport())">
                                    <!-- Empty first cell -->
                                </td>
                                <td
                                    [class]="!isSummaryOrDimensionReport() ? 'group-name-cell-level2' : 'group-data-row'"
                                    [style.background-color]="getGroupRowBackground(subgroup, !isSummaryOrDimensionReport())">
                                    <span [innerHTML]="getSafeHtml(formatValue(subgroup.groupValue, getUnifiedTableColumns()[1]))"></span>
                                </td>

                                <ng-container *ngFor="let column of getUnifiedTableColumns(); let i = index">
                                    <td *ngIf="i>1"
                                        [ngClass]="{'text-right': getColumnInfo(column)?.colDataType == '1'}"
                                        [style.background-color]="getGroupRowBackground(subgroup, !isSummaryOrDimensionReport())">
                                        <span *ngIf="getColumnInfo(column)?.colDataType != '1' && getColumnInfo(column)?.colDataType != 3"
                                        [innerHTML]="getSafeHtml(formatGroupSum(subgroup.groupSums, i, column))"></span>
                                        <span *ngIf="getColumnInfo(column)?.colDataType == '1'">
                                            <a ngClass="cursor-pointer"
                                                *ngIf="shouldShowDrilldownLink(subgroup.groupSums, i, column)"
                                                (click)="getDrilldownReport(subgroup, column, 2, {}, [rowData])">
                                                {{formatGroupSum(subgroup.groupSums, i, column)}}</a>
                                            <span
                                                *ngIf="shouldShowGroupSum(subgroup.groupSums, i, column)">{{formatGroupSum(subgroup.groupSums,
                                                i, column)}}</span>
                                        </span>
                                    </td>
                                </ng-container>
                            </tr>

                            <!-- Level 2 Group Data Rows -->
                            <ng-container *ngIf="shouldShowGroupDetailRows()">
                                <tr *ngFor="let row of subgroup.rows; let rowIndex = index" class="group-data-row">
                                    <td *ngFor="let column of getUnifiedTableColumns(); let i = index"
                                        [ngClass]="{'text-right': getColumnInfo(column)?.colDataType == '1'}">
                                        <ng-container *ngIf="i === 0 || i === 1">
                                            <!-- Empty cell for first two columns -->
                                        </ng-container>
                                        <ng-container *ngIf="i > 1">
                                            <span *ngIf="!isNumericColumn(getColumnInfo(column))"
                                    [innerHTML]="getSafeHtml(formatValue(row[i], column))"></span>
                                            <span *ngIf="isNumericColumn(getColumnInfo(column))">
                                                <a ngClass="cursor-pointer"
                                                    *ngIf="shouldShowRowDrilldownLink(row, i, column)"
                                                    (click)="getDrilldownReport(row, column, 0)">
                                                    {{ getRowDisplayValue(row, i, column) }}
                                                </a>
                                                <span *ngIf="!shouldShowRowDrilldownLink(row, i, column)">
                                                    {{ getRowDisplayValue(row, i, column) }}
                                                </span>
                                            </span>
                                        </ng-container>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </ng-container>

                    <!-- Three Level Grouping -->
                    <ng-container *ngIf="shouldDisplayThreeLevelGrouping()">
                        <!-- Level 1 Group Header Row -->
                        <tr class="group-header-row" [style.background-color]="getGroupRowBackground(rowData)">
                            <td *ngFor="let column of getUnifiedTableColumns(); let i = index"
                                [ngClass]="{'text-right': getColumnInfo(column)?.colDataType == '1'}"
                                [style.background-color]="getGroupRowBackground(rowData)">
                                <b>
                                    <span *ngIf="i==0"
                                    [innerHTML]="getSafeHtml(formatValue(rowData.groupValue, column))"></span>
                                    <span *ngIf="i>0">
                                        <span *ngIf="getColumnInfo(column)?.colDataType != '1' && getColumnInfo(column)?.colDataType != 3"
                                        [innerHTML]="getSafeHtml(formatGroupSum(rowData.groupSums, i, column))"></span>
                                        <span *ngIf="getColumnInfo(column)?.colDataType == '1'">
                                            <a ngClass="cursor-pointer"
                                                *ngIf="shouldShowDrilldownLink(rowData.groupSums, i, column)"
                                                (click)="getDrilldownReport(rowData, column, 1)">
                                                {{formatGroupSum(rowData.groupSums, i, column)}}</a>
                                            <span
                                                *ngIf="shouldShowGroupSum(rowData.groupSums, i, column)">{{formatGroupSum(rowData.groupSums,
                                                i, column)}}</span>
                                        </span>
                                    </span>
                                </b>
                            </td>
                        </tr>

                        <!-- Level 2 Subgroups -->
                        <ng-container *ngFor="let subgroup of rowData.subgroups">
                            <!-- Level 2 Group Header Row -->
                            <tr
                                [class]="!isSummaryOrDimensionReport() ? 'group-header-row-level2' : 'group-data-row'"
                                [style.background-color]="getGroupRowBackground(subgroup, !isSummaryOrDimensionReport())">
                                <td
                                    [class]="!isSummaryOrDimensionReport() ? 'group-name-cell-level2' : 'group-data-row'"
                                    [style.background-color]="getGroupRowBackground(subgroup, !isSummaryOrDimensionReport())">
                                    <!-- Empty first cell -->
                                </td>
                                <td
                                    [class]="!isSummaryOrDimensionReport() ? 'group-name-cell-level2' : 'group-data-row'"
                                    [style.background-color]="getGroupRowBackground(subgroup, !isSummaryOrDimensionReport())">
                                    <span [innerHTML]="getSafeHtml(formatValue(subgroup.groupValue, getUnifiedTableColumns()[1]))"></span>
                                </td>

                                <ng-container *ngFor="let column of getUnifiedTableColumns(); let i = index">
                                    <td *ngIf="i>1"
                                        [ngClass]="{'text-right': getColumnInfo(column)?.colDataType == '1'}"
                                        [style.background-color]="getGroupRowBackground(subgroup, !isSummaryOrDimensionReport())">
                                        <span *ngIf="getColumnInfo(column)?.colDataType != '1' && getColumnInfo(column)?.colDataType != 3"
                                        [innerHTML]="getSafeHtml(formatGroupSum(subgroup.groupSums, i, column))"></span>
                                        <span *ngIf="getColumnInfo(column)?.colDataType == '1'">
                                            <a ngClass="cursor-pointer"
                                                *ngIf="shouldShowDrilldownLink(subgroup.groupSums, i, column)"
                                                (click)="getDrilldownReport(subgroup, column, 2, {}, [rowData])">
                                                {{formatGroupSum(subgroup.groupSums, i, column)}}</a>
                                            <span
                                                *ngIf="shouldShowGroupSum(subgroup.groupSums, i, column)">{{formatGroupSum(subgroup.groupSums,
                                                i, column)}}</span>
                                        </span>
                                    </td>
                                </ng-container>
                            </tr>

                            <!-- Level 3 Subgroups -->
                            <ng-container *ngFor="let subsubgroup of subgroup.subgroups">
                                <!-- Level 3 Group Header Row -->
                                <tr
                                    [class]="!isSummaryOrDimensionReport() ? 'group-header-row-level3' : 'group-data-row'"
                                    [style.background-color]="getGroupRowBackground(subsubgroup, !isSummaryOrDimensionReport())">
                                    <td class="group-name-cell-level3"
                                        [style.background-color]="getGroupRowBackground(subsubgroup, !isSummaryOrDimensionReport())">
                                        <!-- Empty first cell -->
                                    </td>
                                    <td class="group-name-cell-level3"
                                        [style.background-color]="getGroupRowBackground(subsubgroup, !isSummaryOrDimensionReport())">
                                        <!-- Empty second cell -->
                                    </td>
                                    <td class="group-name-cell-level3"
                                        [style.background-color]="getGroupRowBackground(subsubgroup, !isSummaryOrDimensionReport())">

                                        <span [innerHTML]="getSafeHtml(formatValue(subsubgroup.groupValue, getUnifiedTableColumns()[2]))"></span>

                                    </td>
                                    <ng-container *ngFor="let column of getUnifiedTableColumns(); let i = index">
                                        <td *ngIf="i>2"
                                            [ngClass]="{'text-right': getColumnInfo(column)?.colDataType == '1'}"
                                            [style.background-color]="getGroupRowBackground(subsubgroup, !isSummaryOrDimensionReport())">
                                            <span *ngIf="getColumnInfo(column)?.colDataType != '1' && getColumnInfo(column)?.colDataType != 3"
                                        [innerHTML]="getSafeHtml(formatGroupSum(subsubgroup.groupSums, i, column))"></span>
                                            <span *ngIf="getColumnInfo(column)?.colDataType == '1'">
                                                <a ngClass="cursor-pointer"
                                                    *ngIf="shouldShowDrilldownLink(subsubgroup.groupSums, i, column)"
                                                    (click)="getDrilldownReport(subsubgroup, column, 3, {}, [rowData, subgroup])">
                                                    {{formatGroupSum(subsubgroup.groupSums, i, column)}}</a>
                                                <span
                                                    *ngIf="shouldShowGroupSum(subsubgroup.groupSums, i, column)">{{formatGroupSum(subsubgroup.groupSums,
                                                    i, column)}}</span>
                                            </span>
                                        </td>
                                    </ng-container>
                                </tr>

                                <!-- Level 3 Group Data Rows -->
                                <ng-container *ngIf="shouldShowGroupDetailRows()">
                                    <tr *ngFor="let row of subsubgroup.rows; let rowIndex = index"
                                        class="group-data-row">
                                        <td *ngFor="let column of getUnifiedTableColumns(); let i = index"
                                            [ngClass]="{'text-right': getColumnInfo(column)?.colDataType == '1'}">
                                            <ng-container *ngIf="i === 0 || i === 1 || i === 2">
                                                <!-- Empty cell for first three columns -->
                                            </ng-container>
                                            <ng-container *ngIf="i > 2">
                                                <span *ngIf="!isNumericColumn(getColumnInfo(column))"
                                    [innerHTML]="getSafeHtml(formatValue(row[i], column))"></span>
                                                <span *ngIf="isNumericColumn(getColumnInfo(column))">
                                                    <a ngClass="cursor-pointer"
                                                        *ngIf="shouldShowRowDrilldownLink(row, i, column)"
                                                        (click)="getDrilldownReport(row, column, 0)">
                                                        {{ getRowDisplayValue(row, i, column) }}
                                                    </a>
                                                    <span *ngIf="!shouldShowRowDrilldownLink(row, i, column)">
                                                        {{ getRowDisplayValue(row, i, column) }}
                                                    </span>
                                                </span>
                                            </ng-container>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>

                </ng-container>

                <!-- Ungrouped Data Display -->
                <ng-container *ngIf="!isGroupedData()">
                    <tr>
                        <td *ngFor="let column of getUnifiedTableColumns(); let i = index"
                            [ngClass]="{'text-right': getColumnInfo(column)?.colDataType == '1'}">
                            <span *ngIf="formatValue(rowData[i], column) == 'No Access' else elseBlock" class="no-access-text">No Access</span>
                            <ng-template #elseBlock>
                                <a ngClass="cursor-pointer" (click)="getJobDescription(rowData, column)" *ngIf="inArray(column, jobDescriptionColumn) else elseBlock2">Click Here</a>
                                <ng-template #elseBlock2>
    
                                    <span *ngIf="getColumnInfo(column)?.colDataType != '1' && !inArray(column, jobDescriptionColumn)"
                                    [innerHTML]="getSafeHtml(formatValue(rowData[i], column))"></span>
                                    <span *ngIf="getColumnInfo(column)?.colDataType == '1'">
                                        <a ngClass="cursor-pointer" *ngIf="+rowData[i] && (getColumnInfo(column)?.drilldownReportId) && getColumnInfo(column)?.colDataType == '1' else elseBlock3"
                                            (click)="getDrilldownReport(rowData, column, 0)"> {{ getColumnInfo(column)?.isAmountField == 1 ? formatCurrency(rowData[i], rowData) : formatValue(rowData[i],
                                            column)}}</a>
                                        <ng-template #elseBlock3>
                                            <span>{{ getColumnInfo(column)?.isAmountField == 1 ? formatCurrency(rowData[i], rowData) : formatValue(rowData[i], column)}}</span>
                                        </ng-template>
                                    </span>
                                </ng-template>
                            </ng-template>
                        </td>
                    </tr>
                </ng-container>
            </ng-template>
            <ng-template pTemplate="footer" *ngIf="showFooter()">
                <tr  [ngClass]="{'hidden': loading || !isDataLoaded || !hasReportData}">
                    <td   *ngFor="let column of getUnifiedTableColumns(); let i = index"
                        [ngClass]="{'text-right': getColumnInfo(column)?.colDataType == '1'}">
                        <b>
                            <span *ngIf="i==0">Total :</span>
                            <span *ngIf="i>0" [innerHTML]="getSafeHtml(formatOverallTotalSum(i, column))"></span>
                        </b>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="getUnifiedTableColumns().length || 1" class="text-center">
                        <div *ngIf="!loading">No records found</div>
                        <div *ngIf="loading">Loading...</div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="card mt-3" *ngIf="isGraphReport && hasReportData && !showHierarchyReport">
        <bi-line-graph *ngIf="selectedGraphItem=='line-chart'" [reportData]="graphReportState | async"></bi-line-graph>
        <bi-stacked-column-graph *ngIf="selectedGraphItem=='stacked-column-chart'"
            [reportData]="graphReportState | async"></bi-stacked-column-graph>
        <bi-stacked-area-graph *ngIf="selectedGraphItem=='stacked-area-chart'"
            [reportData]="graphReportState | async"></bi-stacked-area-graph>
        <bi-range-area-graph *ngIf="selectedGraphItem=='range-area-chart'"
            [reportData]="graphReportState | async"></bi-range-area-graph>
        <bi-nested-donut-graph *ngIf="selectedGraphItem=='nested-donut-chart'"
            [reportData]="graphReportState | async"></bi-nested-donut-graph>
        <bi-clustered-column-graph *ngIf="selectedGraphItem=='clustered-column-chart'"
            [reportData]="graphReportState | async"></bi-clustered-column-graph>
        <bi-pie-graph *ngIf="selectedGraphItem=='pie-chart'" [reportData]="graphReportState | async"></bi-pie-graph>
        <bi-semi-circle-pie-graph *ngIf="selectedGraphItem=='semi-circle-pie-chart'"
            [reportData]="graphReportState | async"></bi-semi-circle-pie-graph>
        <bi-donut-graph *ngIf="selectedGraphItem=='donut-chart'"
            [reportData]="graphReportState | async"></bi-donut-graph>
        <bi-pyramid-graph *ngIf="selectedGraphItem=='pyramid-chart'"
            [reportData]="graphReportState | async"></bi-pyramid-graph>
        <bi-bar-graph *ngIf="selectedGraphItem=='bar-chart'" [reportData]="graphReportState | async"></bi-bar-graph>
        <bi-column-graph *ngIf="selectedGraphItem=='column-chart'"
            [reportData]="graphReportState | async"></bi-column-graph>
        <bi-curved-column-graph *ngIf="selectedGraphItem=='curved-column-chart'"
            [reportData]="graphReportState | async"></bi-curved-column-graph>
        <bi-step-line-graph *ngIf="selectedGraphItem=='step-line-chart'"
            [reportData]="graphReportState | async"></bi-step-line-graph>
        <bi-smoothed-line-graph *ngIf="selectedGraphItem=='smoothed-line-chart'"
            [reportData]="graphReportState | async"></bi-smoothed-line-graph>
        <bi-funnel-graph *ngIf="selectedGraphItem=='funnel-chart'"
            [reportData]="graphReportState | async"></bi-funnel-graph>
        <bi-lollipop-graph *ngIf="selectedGraphItem=='lollipop-chart'"
            [reportData]="graphReportState | async"></bi-lollipop-graph>
        <bi-draggable-pie-graph *ngIf="selectedGraphItem=='draggable-pie-chart'"
            [reportData]="graphReportState | async"></bi-draggable-pie-graph>
        <bi-spiral-bar-timeline-graph *ngIf="selectedGraphItem=='spiral-bar-timeline-chart'"
            [reportData]="graphReportState | async"></bi-spiral-bar-timeline-graph>
        <bi-spiral-timeline-graph *ngIf="selectedGraphItem=='spiral-timeline-chart'"
            [reportData]="graphReportState | async"></bi-spiral-timeline-graph>
        <bi-fishbone-timeline-graph *ngIf="selectedGraphItem=='fishbone-timeline-chart'"
            [reportData]="graphReportState | async"></bi-fishbone-timeline-graph>
        <bi-serpentine-timeline-graph *ngIf="selectedGraphItem=='serpentine-timeline-chart'"
            [reportData]="graphReportState | async"></bi-serpentine-timeline-graph>
        <bi-road-timeline-graph *ngIf="selectedGraphItem=='road-timeline-chart'"
            [reportData]="graphReportState | async"></bi-road-timeline-graph>
        <bi-linear-timeline-graph *ngIf="selectedGraphItem=='linear-timeline-chart'"
            [reportData]="graphReportState | async"></bi-linear-timeline-graph>
    </div>
    
    <!-- No data message for graph reports -->
    <div class="card mt-3" *ngIf="isGraphReport && !hasReportData">
        <div class="noData">No data found for this report</div>
    </div>
</div>
</div>
<bi-generate-report-form *ngIf="isDataLoaded" [formData]="reportFormData" [reportConfig]="reportConfig"
    [userConfig]="userConfig" [dimensionColumnsOptions]="dimensionColumnsOptions"
    (reportData)="handleReportData($event)" [teamsAndRolesResponse]="teamsAndRolesResponse"
    [savedReportData]="savedReportData" [recordsPerPage]="rows" [stageOptions]="stages"
    [usersListOptionsInput]="usersListOptions"></bi-generate-report-form>

<p-drawer [(visible)]="companyReportsSubMenuDisplay" #drawerRef position="left" [style]="{width: '55vw'}" (onHide)="onDrawerHide($event)">
    <ng-template #headless>
        <div class="p-drawer-header pdrawerHead1">
            <div class="pdrawerLeft">
                <div class="p-drawer-title">Tagged/Saved Reports</div>
                <div class="sbSubTtl">(Select reports categorized by module)</div>
            </div>
            <div class="manTimes col-1 p-0 text-right ml-auto"><i class="pi pi-times" (click)="closeCallback($event)"></i>            </div>
        </div>
        <div class="flex flex-column hdLSdBar h-full">

            <div class="field flex mb-5 align-items-center">
                <div class="col-4 p-0 InpGrp">
                    <p-select [showClear]="true" [filter]="true" optionValue="value" optionLabel="label" #searchModule
                        placeholder="Choose Module" class="w-full gSlct" [options]="getModuleOptions()"
                        [ngModel]="selectedModuleId" (onChange)="onModuleChange($event)" />
                </div>
                <div class="col-7 p-0 InpGrp">
                    <p-iconfield class="w-full">
                        <input #searchString type="text" pInputText class="w-full" (keyup)="onTextSearch($event)"
                            [ngModel]="searchText" />
                        <p-inputicon styleClass="pi pi-search" />
                    </p-iconfield>
                </div>
                
            </div>
            <div class="overflow-y-auto" style="overflow-x: hidden;">
                <div class="grid mb-5">
                    <div class="col-5" [ngClass]="{'mr-6': (reportIndex % 2) == 0}"
                        *ngFor="let report of loadCompanyReports(); let reportIndex = index">
                        <div class="SectHead mb-3">{{report.reportName}}</div>
                        <div class="flex align-items-center mb-3"
                            *ngFor="let savedReport of getVisibleSavedReports(report.savedReports, report.id)">
                            <div class="mdlSubtxt"><a (click)="companyReportsSubMenuDisplay = false; isInitialLoad = false"
                                    routerLink="/report-details/{{savedReport.reportId}}/{{savedReport.id}}"
                                    tooltipPosition="top"
                                    pTooltip="{{savedReport.reportDesc}}">{{savedReport.reportName}}
                                    <div class="ml-auto"><i class="pi pi-angle-right"></i></div>
                                    </a>
                                </div>
                            
                        </div>
                        <div *ngIf="hasMoreReports(report.savedReports, report.id) || showMoreStates[report.id]">
                            <a class="hlink" (click)="toggleShowMore(report.id)">{{getShowMoreText(report.id)}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

</p-drawer>

<!-- Schedule Report Component -->
<bi-schedule-report></bi-schedule-report>

<!-- Report Security Component -->
<bi-report-security></bi-report-security>

<!-- Email Report Component -->
<bi-email-report></bi-email-report>

<!-- Start Drilldown Report Details -->
<bi-drilldown-report
    *ngIf="drilldownReportInfo.visible && Object.keys(drilldownReportInfo).length > 0 && drilldownColumnInfo && drilldownColumnInfo.length > 0"
    [drilldownReportInfo]="drilldownReportInfo" [drilldownColumnInfo]="drilldownColumnInfo"
    [drilldownReportPostData]="drilldownReportPostData">
</bi-drilldown-report>
<!-- End Drilldown Report Details -->

<bi-mobile-view *ngIf="mobileReportInfo.visible && Object.keys(mobileReportInfo).length > 0" [mobileReportInfo]="mobileReportInfo"></bi-mobile-view>

<p-dialog header="Report API" [(visible)]="customReportApiPopup" [modal]="true" class="copyurlpop"
     [closable]="true" [draggable]="false" [resizable]="true" position="top" [style]="{width: '45vw'}">
    <div class="flex flex-column align-items-left justify-content-left">
        <div class="text-left">
            <p>Use the following API to get the report data.</p>
            <div class="copyUrl">
                <code>{{apiConfigUrl}}/report-details/get-report-data/{{savedReportData?.savedReports?.[0]?.encryptedId || (customReportApiLoading ? 'loading...' : 'unavailable')}}?response_type=1</code>
                <!-- <code>https://atsbi.ceipal.com/api/report-details/get-report-data/{{savedReportData?.savedReports?.[0]?.encryptedId || 'loading...'}}?response_type=1</code> -->
            </div>
            <div class="flex gap-2">
                <p-button 
                    label="Copy URL" 
                    icon="pi pi-copy" 
                    (onClick)="copyReportApiUrl()"
                   >
                </p-button>
                <p-button 
                    label="Download Documentation" 
                    icon="pi pi-download" 
                    (onClick)="downloadReportApiUrl()"
                    [outlined]="true"
                    severity="info">
                </p-button>
            </div>
        </div>
    </div>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="showJobDescriptionPopup" [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
  <ng-template pTemplate="header">
    <h6>{{jobCode }} - {{currentJobTitle}}</h6>
  </ng-template>
  <ng-template pTemplate="body">
    <div [innerHTML]="currentJobDescription"></div>
    <b *ngIf="notesCreatedAt">{{notesCreatedBy}} : </b> <span> {{notesCreatedAt | date:'dd-MM-yyyy HH:mm'}}</span>
    <div>
      <b *ngIf="notesDescription">Note Description : </b> 
      <span  [innerHTML]="notesDescription"></span>
    </div>
  </ng-template>
</p-dialog>
